import { createStack } from 'hub-http';
import hubApiStack from 'hub-http/stacks/hubapi';
import promiseClient from 'hub-http/adapters/promiseClient';
import noAuthWithCredentialsHubapi from 'hub-http/stacks/noAuthWithCredentialsHubapi';
import { sendRavenOnResponseError } from './middlewares';
export const httpClientWithRaven = promiseClient(createStack(hubApiStack, sendRavenOnResponseError));
export const noAuthHttpClientWithRaven = promiseClient(createStack(noAuthWithCredentialsHubapi, sendRavenOnResponseError));